'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineOverlayCloseButton = require('./components/InlineOverlayCloseButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineOverlayCloseButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay-close-button/index.js
// module id = 521
// module chunks = 1